import { FormField, getErrors, NumberInput } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps } from 'react';

type NumberFieldProps = {
  inputOverrides?: ComponentProps<typeof NumberInput>;
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function NumberField(props: NumberFieldProps) {
  const { inputOverrides, ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <NumberInput
          value={parseInt(field.state.value)}
          onChange={field.handleChange}
          {...inputOverrides}
        />
      }
    />
  );
}
